import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=c89b052e&scoped=true"
import script from "./Company.vue?vue&type=script&lang=js"
export * from "./Company.vue?vue&type=script&lang=js"
import style0 from "./Company.vue?vue&type=style&index=0&id=c89b052e&prod&scoped=true&lang=scss"
import style1 from "./Company.vue?vue&type=style&index=1&id=c89b052e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89b052e",
  null
  
)

export default component.exports